import { adapter, initialState } from './state'
import { createReducer, on } from '@ngrx/store'
import {
  LoadCustomAttributesComplete,
  AddCustomAttributeComplete,
  LoadCustomAttributesByEntityTypeComplete,
  AddCustomAttribute,
} from './actions'

export const reducer = createReducer(
  initialState,
  on(LoadCustomAttributesComplete, (state, { items }) => adapter.setAll(items, { ...state, isLoaded: true })),
  on(AddCustomAttributeComplete, (state, { item }) => adapter.setOne(item, { ...state, isSaving: false })),
  on(LoadCustomAttributesByEntityTypeComplete, (state, { item }) => adapter.setOne(item, state)),
  on(AddCustomAttribute, (state) => ({ ...state, isSaving: true }))
)

export const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors()
